import { PlusOutlined } from "@ant-design/icons";
import { Lookup } from "@comps";
import { ColumnProps } from "@comps/types";
import {
  Card as AdCard,
  Button,
  Col,
  Form,
  Input,
  Row,
  Table as AdTable,
} from "antd";
import * as React from "react";
import { useState } from "react";

interface Props {
  form: any;
  showCard?: boolean;
}

interface PayCodeOption {
  label: string;
  value: string;
}

const PaymentFormList: React.FC<Props> = ({ form, showCard = true }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [payCodeOptions, setPayCodeOptions] = useState<PayCodeOption[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleAdd = (add: any) => {
    add({});
  };

  const handleDel = (fields: any[]) => {
    const removeIndexes: number[] = [];
    selectedRowKeys.forEach((item) => {
      fields.forEach((field: any) => {
        if (String(field.key) === String(item)) {
          removeIndexes.push(field.name);
        }
      });
    });
    if (!removeIndexes.length) {
      return;
    }

    const payLines = [...(form.getFieldValue("payLines") || [])];
    removeIndexes.sort((a, b) => b - a).forEach((idx) => payLines.splice(idx, 1));

    form.setFieldsValue({ payLines });
    setSelectedRowKeys([]);
  };

  const columns: ColumnProps[] = [
    {
      key: "lineNum",
      title: "序号",
      width: 80,
      render: (text: any, field: any, index: number) => (
        <>
          <Form.Item
            style={{ display: "none", margin: 0 }}
            name={[field.name, "lineNum"]}
            fieldKey={[field.fieldKey, "lineNum"]}
          >
            <Input />
          </Form.Item>
          {index + 1}
        </>
      ),
    },
    {
      key: "payCode",
      dataIndex: "payCode",
      title: "支付渠道",
      render: (text: any, field: any) => (
        <>
          <Form.Item
            style={{ display: "none", margin: 0 }}
            name={[field.name, "payName"]}
            fieldKey={[field.fieldKey, "payName"]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{ margin: 0 }}
            name={[field.name, "payCode"]}
            fieldKey={[field.fieldKey, "payCode"]}
          >
            <Lookup
              lookupType="PAY_CODE_TYPE"
              placeholder="请选择"
              KVList={(list: any[]) => {
                setPayCodeOptions(
                  (list || []).map((item: any) => ({
                    value: item.k,
                    label: item.v,
                  }))
                );
              }}
              onChange={(value: string) => {
                const payLines = [...(form.getFieldValue("payLines") || [])];
                const current = payLines[field.name] || {};
                const selected = payCodeOptions.find(
                  (item) => String(item.value) === String(value)
                );
                payLines[field.name] = {
                  ...current,
                  payCode: value,
                  payName: selected?.label || "",
                };
                form.setFieldsValue({ payLines });
              }}
            />
          </Form.Item>
        </>
      ),
    },
    {
      key: "transactionNo",
      dataIndex: "transactionNo",
      title: "交易单号",
      render: (text: any, field: any) => (
        <Form.Item
          style={{ margin: 0 }}
          name={[field.name, "transactionNo"]}
          fieldKey={[field.fieldKey, "transactionNo"]}
        >
          <Input placeholder="请输入" />
        </Form.Item>
      ),
    },
  ];

  return (
    <Form.List name="payLines" key="payLines">
      {(fields, { add }) => {
        return (
          <>
            {showCard ? (
              <Row style={{ marginTop: "16px" }}>
                <Col span={24}>
                  <AdCard title="支付信息">
                    <Row>
                      <Button
                        style={{ marginRight: "5px" }}
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => handleAdd(add)}
                      >
                        增行
                      </Button>
                      <Button
                        disabled={!selectedRowKeys.length}
                        onClick={() => handleDel(fields)}
                      >
                        删除
                      </Button>
                    </Row>
                  </AdCard>
                </Col>
              </Row>
            ) : (
              <Row style={{ marginTop: "16px", marginBottom: "8px" }}>
                <Col span={24}>
                  <Row>
                    <Button
                      style={{ marginRight: "5px" }}
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => handleAdd(add)}
                    >
                      增行
                    </Button>
                    <Button
                      disabled={!selectedRowKeys.length}
                      onClick={() => handleDel(fields)}
                    >
                      删除
                    </Button>
                  </Row>
                </Col>
              </Row>
            )}
            <AdTable
              dataSource={fields}
              columns={columns}
              rowKey="key"
              pagination={false}
              tableLayout="fixed"
              rowSelection={{
                onChange: onSelectChange,
                selectedRowKeys,
                preserveSelectedRowKeys: false,
              }}
            />
          </>
        );
      }}
    </Form.List>
  );
};

export default PaymentFormList;
